import React from 'react';
import {
    Box,
    H1,
    H2,
    H3,
    Grid,
} from '@saladbob/sassafras';

import getSite from '../../../../crud/getSite';
import getHostBySlug from '../../../../crud/getHostBySlug';
import Layout from '../../../../components/Layout';
import HostLayout from '../../../../components/hosts/Layout';
import Blocks from '../../../../components/blocks/Blocks';
import CourtListing from '../../../../components/brackets/CourtListing';

// Crud

import { publishedByTournament, publishedByTournamentFinished } from '../../../../crud/gql/Brackets';
import fetchGql from '../../../../crud/fetchGql';


import type { NextPageWithLayout, PageProps } from '../../../_app';
import Host from '../../../../types/Host';
import type { CourtDepth } from '../../../../types';
import type { BracketDepth } from '../../../../types/Bracket';

type Props = {
    host: Host,
    courts: CourtDepth[] | null,
    bracket: BracketDepth | null,
    Header: React.FC,
};

const hostgql = `query {
    Hosts(where: { activeTournament: { exists: true } }, limit: 200 ) {
      docs {
        id
        slug
        activeTournament {
            id
        }
      }
    }
  }`;

export async function getStaticPaths() {
    return {
        paths: [],
        fallback: 'blocking', // can also be true or 'blocking'
    }
}

export async function getStaticProps({ params}) {
    if (!params.id || params.id  === 'undefined') {
        return {
            notFound: true,
        }
    }

    const site = await getSite();
    const host = await getHostBySlug(process.env.NEXT_PUBLIC_API_URL, params.id);

    if (!host) {
        return {
            notFound: true,
        }
    }

    const brackets = await fetchGql({
        query: host.activeTournament?.status === 'finished' ? publishedByTournamentFinished : publishedByTournament,
        variables: {
            id: host.activeTournament.id,
        },
    });

    return {
        props: {
            metaTitle: host?.name,
            bracket: brackets.data.Brackets.docs[0] || null,
            courts: brackets.data.Brackets.docs[0].courts,
            host,
            ...site,
        },
    }
}

const Page: NextPageWithLayout<Props> = ({ host, bracket, courts }) => {
    if (!host || !bracket || !courts) {
        return (
            <Box>
                <H3>Brackets are not available at this time.</H3>
            </Box>
        )
    }
    return (
        <Box>
            {host.eventLayout && host.eventLayout.length > 0 && (
                <>
                    <Blocks blocks={host.eventLayout} />
                    <Box pt="lg" bdWidth="1px 0 0 0" bdColor="neutral200">
                        <H1 margin={[0, 'lg']}>Courts</H1>
                    </Box>
                </>
            )}
            <CourtListing host={host} courts={courts} bracketId={bracket.id} />
        </Box>
    );
};

Page.getLayout = function getLayout(page: React.ReactElement, pageProps: PageProps & Props ) {
    return (
        <Layout { ...pageProps }>
            <HostLayout page="brackets" brackets {...pageProps}>
                {page}
            </HostLayout>
        </Layout>
    )
}

export default Page;